import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Load store modules dynamically.
const storeModules = import.meta.glob('./modules/*.js', { eager: true })

const modules = Object.entries(storeModules)
  .map(([path, mod]) => [path.replace(/^.*\/(.*)\.js$/, '$1'), { ...mod }])
  .reduce((modules, [name, mod]) => {
    if (mod.namespaced === undefined) {
      mod.namespaced = true
    }

    return { ...modules, [name]: mod }
  }, {})

export default new Vuex.Store({
  modules,
})
